import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    greet() {
        eproc.toast.success("Hello world, from Stimulus")
    }
}